import { Checkbox, ControlLabel, DropdownItem } from 'gu-ui-kit'
import isEqual from 'lodash/isEqual'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import isObject from 'lodash/isObject'
import ActionButtons from 'components/Filters/ActionButtons'
import styles from 'components/Filters/FilterPanel/subcomponents/Dropdown/Dropdown.module.scss'

const CheckboxGroupFilter = ({
  name,
  onApply = () => {},
  showActionButtons = true,
  onSelect = () => {},
  value = [],
  options = [],
  defaultValue = [],
  optionLabelPrefix = '',
  lock = false,
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(value)

  useEffect(() => {
    !isEqual(checked, value) && setChecked(value)
  }, [value])

  useEffect(() => {
    onSelect(checked)
  }, [checked])

  const toggle = useCallback(
    (toggledValue) => {
      if (lock) return

      if (checked.includes(toggledValue)) {
        setChecked((prevState) =>
          prevState.filter((checkboxItem) => checkboxItem !== toggledValue),
        )
      } else {
        setChecked((prevState) => [...prevState, toggledValue])
      }
    },
    [checked, setChecked, lock],
  )

  const applyValue = useCallback(
    () => onApply({ fieldName: name, value: checked }),
    [checked],
  )

  const dropFilter = useCallback(() => setChecked(defaultValue), [setChecked])

  return (
    <>
      <div className={styles['dropdown__scroll']}>
        {options.map((option) => {
          const { label, value } = isObject(option)
            ? option
            : { label: t(optionLabelPrefix + option), value: option }
          return (
            <DropdownItem key={name + '-option-' + value} size={'m'}>
              <ControlLabel
                onChange={() => {
                  toggle(value)
                }}
                checked={checked.includes(value)}
                value={value}
                name={name}
                control={<Checkbox />}
                label={label}
              />
            </DropdownItem>
          )
        })}
      </div>

      <ActionButtons
        dropFilter={dropFilter}
        applyValue={applyValue}
        showActionButtons={showActionButtons}
      />
    </>
  )
}

CheckboxGroupFilter.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onApply: PropTypes.func,
  showActionButtons: PropTypes.bool,
  onSelect: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.any,
  optionLabelPrefix: PropTypes.string,
  options: PropTypes.array,
  lock: PropTypes.bool,
}

export default CheckboxGroupFilter
